/** @format */

import React, { FunctionComponent } from 'react';
import I18n from '../../components/Translate/I18n';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

export type ErrorFunctionName = {
    name: string | null;
};

export const ErrorElement: FunctionComponent<ErrorFunctionName> = ({ name }) => (
    <TableRow>
        <TableCell padding="none" align="left">
            <I18n trans="prov:f.get_fail" />
        </TableCell>
        <TableCell padding="none" align="right">
            <I18n trans={name} />
        </TableCell>
    </TableRow>
);
